import { EmptyState, Flex, Text } from '@buffer-mono/popcorn'
import * as m from 'motion/react-m'

import { CommentsEngagementPanel } from '../CommentsEngagementPanel'
import type { EmptyStateChannel } from './types'
import { EmptyStateWrapper } from '../../../components/EmptyStates'
import { isGoogleBusinessProfile } from '../../../util/channelHelpers'

import styles from './ActivelyEngaging.module.css'

import type { JSX } from 'react'

const EmptyStateIconMotion = m.create(EmptyState.Icon)

type ActivelyEngagingProps = {
  activeTime: string
  shouldAnimate?: boolean
  channels?: EmptyStateChannel[]
  postId?: string
}

export const ActivelyEngaging = ({
  activeTime,
  shouldAnimate,
  channels,
  postId,
}: ActivelyEngagingProps): JSX.Element => {
  const isGBP = isGoogleBusinessProfile(channels)
  const itemLabel = isGBP ? 'reviews' : 'comments'

  return (
    <EmptyStateWrapper shouldAnimate={shouldAnimate}>
      <EmptyState
        size="large"
        variant="success"
        // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- EmptyState is the labelled live status while retaining its Popcorn presentation.
        role="status"
        aria-label={`All ${itemLabel} have been addressed`}
        className={styles.wrapper}
      >
        <Flex gap="xs" direction="column" align="center">
          <div className={styles.animationContainer} aria-hidden="true">
            <EmptyStateIconMotion
              className={styles.emptyStateIcon}
              animate={{
                scale: [1, 1.2, 1],
                transition: {
                  duration: 1,
                },
                backgroundColor: [
                  'var(--color-bg-success-subtle)',
                  'var(--global-color-green-300)',
                  'var(--color-bg-success-subtle)',
                ],
              }}
            />
            <Text
              className={styles.activelyEngagingTime}
              color="success"
              aria-live="polite"
            >
              {activeTime}
            </Text>
          </div>
          <Text size="md" color="subtle" weight="bold">
            Session duration
          </Text>
        </Flex>
        <EmptyState.Heading>
          Well done on being productive and avoiding doom scrolling 👏
        </EmptyState.Heading>
        <EmptyState.Description>
          You&apos;re all caught up! We will let you know when new {itemLabel}{' '}
          appear.
        </EmptyState.Description>
      </EmptyState>
      <CommentsEngagementPanel channels={channels ?? []} postId={postId} />
    </EmptyStateWrapper>
  )
}
